"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnalyticsController = function () {
    function AnalyticsController(AnalyticsService, $q) {
        "ngInject";

        (0, _classCallCheck3.default)(this, AnalyticsController);
        this.analyticsService = AnalyticsService;
        this.$q = $q;
    }

    (0, _createClass3.default)(AnalyticsController, [{
        key: "$onInit",
        value: function $onInit() {
            var _this = this;

            this.isLoading = true;

            var getDataSetsPromise = this.analyticsService.getDataSets();

            this.$q.all([getDataSetsPromise]).then(function (data) {
                var _data = (0, _slicedToArray3.default)(data, 1),
                    getDataSetsResponse = _data[0];

                _this.setDataSetsOptions(getDataSetsResponse);

                _this.isLoading = false;
            });
        }
    }, {
        key: "setDataSetsOptions",
        value: function setDataSetsOptions(set) {
            this.registrationsOverTimeGridOptions = this.getGridOptions(set[0]);
            this.approvalsOverTimeGridOptions = this.getGridOptions(set[1]);
            this.helperApprovalsOverTimeGridOptions = this.getGridOptions(set[17]);

            this.firstTimePayingCustomersGridOptions = this.getGridOptions(set[2]);
            this.organicFirstTimePayingCustomersGridOptions = this.getGridOptions(set[3]);
            this.paidFirstTimePayingCustomersGridOptions = this.getGridOptions(set[4]);

            this.recurringPayingCustomersGridOptions = this.getGridOptions(set[5]);
            this.aggregateTotalsGridOptions = this.getGridOptions(set[6]);

            this.organicFirstTimePayingCustomersRevenueGridOptions = this.getGridOptions(set[7]);
            this.paidFirstTimePayingCustomersRevenueGridOptions = this.getGridOptions(set[8]);

            this.firstTimePayingCustomersSummaryGridOptions = this.getGridOptions(set[9]);
            this.firstTimePayingCustomersRevenueSummaryGridOptions = this.getGridOptions(set[10]);

            this.recurringPayingCustomersSummaryGridOptions = this.getGridOptions(set[11]);
            this.recurringPayingCustomersRevenueSummaryGridOptions = this.getGridOptions(set[12]);

            this.auFamilyRegistrationsBySource = this.getGridOptions(set[13]);
            this.nzFamilyRegistrationsBySource = this.getGridOptions(set[14]);
            this.auHelperRegistrationsBySource = this.getGridOptions(set[15]);
            this.nzHelperRegistrationsBySource = this.getGridOptions(set[16]);
            this.registrationsByCountry = this.getGridOptions(set[18]);

            // this.firstTimeQSPayingCustomersGridOptions = this.getGridOptions(set[4]);
            // this.firstTimeASPayingCustomersGridOptions = this.getGridOptions(set[5]);
            // this.redemptionsGridOptions = this.getGridOptions(set[6]);
        }
    }, {
        key: "getGridOptions",
        value: function getGridOptions(set) {
            var data = set.data;
            var columns = set.dataInfo;
            columns[0].width = "250px";

            return {
                dataSource: {
                    data: data,
                    pageable: false
                },
                columns: columns,
                scrollable: false,
                sortable: false,
                filterable: false
            };
        }
    }]);
    return AnalyticsController;
}();

exports.default = AnalyticsController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/analytics-data/analytics-data.controller.js
 **/